import React from "react";

import { FileViewer, Modal } from "@amphore-dev/amphore-lib";
import { t } from "i18next";
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";
import { pdfjs } from "react-pdf";

// Same reason as ReportSubmitModal: the lib's FileViewer falls back to a
// worker path that does not resolve in its own build; setting it here,
// resolved by Chronos's Vite build, wins.
pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

interface IInvoicePreviewModalProps {
	file: File | null;
	onClose: () => void;
	footer?: React.ReactNode;
}

/** The rendered PDF in a modal, with whatever buttons the caller adds under it. */
export const InvoicePreviewModal: React.FC<IInvoicePreviewModalProps> = ({
	file,
	onClose,
	footer,
}) => (
	<Modal
		open={!!file}
		onClose={onClose}
		size="lg"
		title={t("invoices.actions.preview")}
	>
		{file && (
			<div className="-mt-4 h-[75vh]">
				<FileViewer src={file} name={file.name} />
			</div>
		)}
		{footer && <div className="mt-4 flex justify-end gap-2">{footer}</div>}
	</Modal>
);
